import { api } from '@/lib/api';
import type { NotificationItem } from './types';

export async function fetch_notifications(unread = false, limit = 30): Promise<NotificationItem[]> {
  const res = await api.get<NotificationItem[]>('/user/notifications', { params: { unread: unread || undefined, limit } });
  return res.data;
}

export async function fetch_unread_count(): Promise<number> {
  const res = await api.get<{ count: number }>('/user/notifications/unread-count');
  return res.data.count;
}

export async function mark_notification_read(id: string): Promise<NotificationItem> {
  const res = await api.post<NotificationItem>(`/user/notifications/${id}/read`);
  return res.data;
}

export async function mark_all_notifications_read(): Promise<void> {
  await api.post('/user/notifications/read-all');
}
